import {useSessionExpiration} from '../auth/hooks/useSessionExpiration';
import {FullScreenLoading} from '../common/Loading';
import {configuration} from '../config';
import {ComponentWithRequiredChildren, PropsWithRequiredChildren} from '../react/types';
import {ExtendSessionModal} from './ExtendSessionModal';

// This component must be a child of WithCurrentUser
export const WithSessionExpiration: ComponentWithRequiredChildren = ({children}: PropsWithRequiredChildren) => {
  /*
   * Firebase auth has no built-in mechanism to enforce maximum session lengths, so we start a timer based on the
   * initial auth time that will log the user out after the configured maximum session length.
   * See: https://medium.com/@jwngr/implementing-firebase-auth-session-durations-82fa7b1fff08
   */

  const {sessionExpiration} = configuration;
  const sessionState = useSessionExpiration(sessionExpiration);

  if (sessionState.loading) {
    return <FullScreenLoading />;
  }

  const expirationWarningPeriodMinutes = sessionExpiration?.sessionExtension?.warningPeriodMinutes ?? 0;
  const extendSessionModal =
    sessionState.willExpire && sessionState.canExtend && expirationWarningPeriodMinutes > 0 ? (
      <ExtendSessionModal
        minutesBeforeExpiration={expirationWarningPeriodMinutes}
        sessionExpirationTime={sessionState.expiresAt}
      />
    ) : undefined;

  return (
    <>
      {extendSessionModal}
      {children}
    </>
  );
};
